import ColumnBase from "./ColumnBase.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ICON_COL_DEF_WIDTH } from "../../other/constants/OtherKeys.jsx";
import { defaultGroupRenderer, isMediaFile, openGeneralWidgetFromGridRecord } from "../../other/utils/utils.jsx";
import { WIDGET_REGISTRY } from "../../other/constants/EntityManagerConfig.tsx";
import { HasIconColumnTooltipMixin } from "./mixins/HasIconColumnTooltipMixin.jsx";
import {
  formatFileTooltipItems,
  handleFileTooltipClick,
  queryBoardFilesForEntity,
} from "../../other/utils/filesColumnUtils.ts";

const TOOLTIP_CLS = "swivu-documents-files-icon-tooltip";

const getDocumentsIcon = (hasData = false) => {
  const color = hasData ? "text-[#0a88e9]" : "";
  return `<i class="${TOOLTIP_CLS} fa-regular fa-file-lines ${color}"></i>`;
};

export default class DocumentsColumn extends HasIconColumnTooltipMixin(ColumnBase) {
  static get $name() {
    return "DocumentsColumn";
  }

  static get type() {
    return WIDGET_KEYS.documentsColumn;
  }

  static get defaults() {
    return {
      text: "Documents",
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      editor: false,
      searchable: false,
      align: "center",
      field: "hasDocumentFiles",
      cellCls: "cursor-pointer",
      cls: "swivu-icon-column",
      sealed: true,
      filterable: false,
      htmlEncode: false,
      renderer({ value }) {
        return getDocumentsIcon(value);
      },
      groupRenderer({ groupRowFor, ...rest }) {
        return defaultGroupRenderer({ groupRowFor: getDocumentsIcon(groupRowFor), ...rest });
      },
      headerRenderer() {
        return getDocumentsIcon();
      },
    };
  }

  getTooltipSelector() {
    return `.${TOOLTIP_CLS}`;
  }

  getTooltipItems(record) {
    return queryBoardFilesForEntity(this.project, record).filter((file) => !isMediaFile(file));
  }

  formatTooltipItems(records) {
    return formatFileTooltipItems(records);
  }

  handleTooltipClick(event, _record) {
    handleFileTooltipClick(event, this);
  }

  onSwivuColumnClick(e) {
    openGeneralWidgetFromGridRecord(this.editorHandler, e.record, WIDGET_REGISTRY.documents.id, {
      idSuffix: "documents",
    });
  }
}

ColumnStore.registerColumnType(DocumentsColumn);
